import { EquipamentoRow, EstoqueLocal, ItemDoFiltro, PracaDoFiltro } from '../../../../types/estoque'

export const TODAS: PracaDoFiltro = 'todas'
export const TODOS: ItemDoFiltro = 'todos'

export const podeVerTodasAsPracas = (locais: Pick<EstoqueLocal, 'noEscopo'>[]): boolean =>
  locais.filter((l) => l.noEscopo).length > 1

export function lerPraca(valor: string): PracaDoFiltro | null {
  if (valor === TODAS) return TODAS
  const n = Number(valor)
  return Number.isInteger(n) && n > 0 ? n : null
}

export function lerItem(valor: string): ItemDoFiltro {
  const n = Number(valor)
  return Number.isInteger(n) && n > 0 ? n : TODOS
}

export function filtrosIniciais(
  salvo: { localId?: unknown; itemId?: unknown } | null,
  locais: Pick<EstoqueLocal, 'id' | 'noEscopo'>[],
): { localId: PracaDoFiltro | null; itemId: ItemDoFiltro } {
  const doEscopo = locais.filter((l) => l.noEscopo)
  const itemId = lerItem(String(salvo?.itemId ?? ''))
  if (!doEscopo.length) return { localId: null, itemId }
  if (salvo?.localId === TODAS && podeVerTodasAsPracas(locais)) return { localId: TODAS, itemId }
  const salvoNoEscopo = doEscopo.find((l) => l.id === Number(salvo?.localId))
  if (salvoNoEscopo) return { localId: salvoNoEscopo.id, itemId }
  return { localId: podeVerTodasAsPracas(locais) ? TODAS : doEscopo[0].id, itemId }
}

export const tituloDaPeca = (u: Pick<EquipamentoRow, 'itemNome' | 'itemAtivo'>): string =>
  u.itemAtivo ? u.itemNome : `${u.itemNome} (item inativo)`
